import React from 'react';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import PrimaryCommentEditorContainer from '../containers/UGCTestContainers/PrimaryCommentEditorContainer';
import PrimaryContentAdvisoryEditorContainer from '../containers/UGCTestContainers/PrimaryContentAdvisoryEditorContainer';
import PrimaryQuotationEditorContainer from '../containers/UGCTestContainers/PrimaryQuotationEditorContainer';
import PrimarySummaryEditorContainer from '../containers/UGCTestContainers/PrimarySummaryEditorContainer';
import NotFound from '@bibliocommons/not-found';
import FeatureFlagContainer from '../containers/FeatureFlagContainer';
import './UGCTestLayout.scss';

class UGCTestLayout extends BcReactComponent {
  static renderMainLayout() {
    return (
      <div className="ugc-test-layout">
        <h1>UGC Editors</h1>

        <div className="ugc-editor">
          <h2>PrimaryContentAdvisoryEditor</h2>
          <PrimaryContentAdvisoryEditorContainer
            bibId="S30C2638413"
            metadataId="S30C2638413" />
        </div>

        <div className="ugc-editor">
          <h2>PrimaryCommentEditor</h2>
          <PrimaryCommentEditorContainer
            bibId="S30C2638413"
            metadataId="S30C2638413" />
        </div>

        <div className="ugc-editor">
          <h2>PrimaryQuotationEditor</h2>
          <PrimaryQuotationEditorContainer
            bibId="S30C2638413"
            metadataId="S30C2638413" />
        </div>

        <div className="ugc-editor">
          <h2>PrimarySummaryEditor</h2>
          <PrimarySummaryEditorContainer
            bibId="S30C2638413"
            metadataId="S30C2638413" />
        </div>
      </div>
    );
  }

  render() {
    return (
      <FeatureFlagContainer>
        {(flags) => flags.get('ugcTestbed') ? UGCTestLayout.renderMainLayout() : <NotFound /> }
      </FeatureFlagContainer>
    );
  }
}

export default UGCTestLayout;



// WEBPACK FOOTER //
// ./app/components/UGCTestLayout.jsx